import Symbol from "./Symbol";
import SymbolAnim from "./SymbolAnim";

export default class SymbolOrange extends Symbol {
    constructor(commander, speed) {
        super(commander, speed);
    }

    init() {
        this.texture = PIXI.Texture.from("symbol_Orange_particle.png");
    }

    startShine(symbol) {
        return new Promise(res => {
            let shine = SymbolAnim.createSprite(symbol.x, symbol.y+10, symbol.name+"_shine.png");
            this.layer.addChild(shine);

            createjs.Tween.get(shine.scale)
                .to({x: 0.9, y: 0.9}, 200 * this.speed, createjs.Ease.linear)
                .to({x: 1, y: 1}, 200 * this.speed, createjs.Ease.linear)
                .wait(300 * this.speed)
                .call(() => {
                    SymbolAnim.removeTween(shine.scale);
                    res(shine);
                });
        });
    }

    startParticles(symbol) {
        return new Promise(res => {
            let pt = [
                {x: symbol.x, y: symbol.y},
                {x: symbol.x+25, y: symbol.y+25},
                {x: symbol.x-25, y: symbol.y-25}
            ];
            createjs.Tween.get()
                .wait(230*this.speed)
                .call(() => {
                    SymbolAnim.runEmitter(this.createBigEmitter(pt[0].x, pt[0].y));
                })
                .wait(600*this.speed)
                .call(() => {
                    this.createSpark(pt[1].x, pt[1].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pt[1].x, pt[1].y));
                })
                .wait(200*this.speed)
                .call(() => {
                    this.createSpark(pt[2].x, pt[2].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pt[2].x, pt[2].y));
                })
                .wait(300*this.speed)
                .call(() => {
                    res();
                });
        })
    }
}